'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopSlide = void 0;
const swiper_1 = require("swiper");
const modules_1 = require("swiper/modules");
class TopSlide {
    constructor() {
        // メインビジュアルのスライド画像
        const mainVisualSwiper = new swiper_1.default(".bulletMainVisualSlider", {
            modules: [modules_1.Autoplay, modules_1.EffectFade],
            loop: true,
            autoplay: true,
            effect: "fade",
            speed: 1000,
            slidesPerView: 1,
        });
        // ACADEMICSの画像スライダー
        const academicsLeftSwiper = new swiper_1.default(".bulletAcademicsSliderLeft", {
            modules: [modules_1.Autoplay],
            loop: true,
            allowTouchMove: false,
            slidesPerView: 'auto',
            spaceBetween: 10,
            speed: 6000,
            direction: 'horizontal',
            autoplay: {
                delay: 1,
            },
            breakpoints: {
                // スライドの表示枚数：1200px以上の場合
                1200: {
                    direction: "vertical",
                },
            }
        });
        const academicsRightSwiper = new swiper_1.default(".bulletAcademicsSliderRight", {
            modules: [modules_1.Autoplay],
            loop: true,
            allowTouchMove: false,
            slidesPerView: 'auto',
            spaceBetween: 10,
            speed: 6000,
            direction: 'horizontal',
            autoplay: {
                delay: 1,
                reverseDirection: true,
            },
            breakpoints: {
                // スライドの表示枚数：1200px以上の場合
                1200: {
                    direction: "vertical",
                },
            }
        });
    }
}
exports.TopSlide = TopSlide;
exports.default = TopSlide;
